import React from 'react';
import {Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';

type Props = {
    onClick?: () => void;
    text?: string;
};

export const AILabel = (props: Props) => {
    const {onClick, text} = props;

    return (
        <div className={styles.component} onClick={onClick}>
            <Icon icon={PriorityIcon.ai_stars} componentClasses={styles.icon}></Icon>

            <Text skin="paragraph-2" wrap={false}>
                {text}
            </Text>
        </div>
    );
};
